import * as React from "react"

import * as CollapsiblePrimitives from "@radix-ui/react-collapsible"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "../../cn"

/* ── CVA variants ─────────────────────────────────────────── */

const collapsibleContentVariants = cva([
  "overflow-hidden text-sm text-coval-text",
  "data-[state=open]:animate-collapsible-down",
  "data-[state=closed]:animate-collapsible-up",
])

/* ── Collapsible (root) ───────────────────────────────────── */

const Collapsible = CollapsiblePrimitives.Root

/* ── CollapsibleTrigger ───────────────────────────────────── */

const CollapsibleTrigger = CollapsiblePrimitives.CollapsibleTrigger

/* ── CollapsibleContent ───────────────────────────────────── */

export interface CollapsibleContentProps
  extends
    React.ComponentPropsWithoutRef<
      typeof CollapsiblePrimitives.CollapsibleContent
    >,
    VariantProps<typeof collapsibleContentVariants> {}

const CollapsibleContent = React.forwardRef<
  React.ComponentRef<typeof CollapsiblePrimitives.CollapsibleContent>,
  CollapsibleContentProps
>(({ className, children, ...props }, ref) => (
  <CollapsiblePrimitives.CollapsibleContent
    ref={ref}
    className={cn(collapsibleContentVariants(), className)}
    {...props}
  >
    {children}
  </CollapsiblePrimitives.CollapsibleContent>
))

CollapsibleContent.displayName = "CollapsibleContent"

export {
  Collapsible,
  CollapsibleTrigger,
  CollapsibleContent,
  collapsibleContentVariants,
}
